import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"pa-0 ma-0",attrs:{"fluid":""}},[_c(VDataTable,{attrs:{"dense":"","headers":_vm.headers,"items":_vm.data},scopedSlots:_vm._u([{key:"item.billRate",fn:function({ item }){return [_vm._v("\n      "+_vm._s(_vm._f("currency")(item.billRate))+"\n    ")]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }